import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'
import { ClinNotification } from '../../../../components/ClinNotification'
import { ClinAnnounceBar } from '../../../../components/ClinAnnounceBar'
import { ClinText } from '../../../../components/ClinText'

export const StyledProductInformation = styled.div`
  width: 100%;
  text-align: left;
`

export const StyledItemDetails = styled.div({})

export const StyledDocumentsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;

  span {
    font-weight: ${ClinTheme.fontWeights.normal};
    margin-top: 8px;
    display: block;
    height: fit-content;
  }
`

export const Row = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: ClinTheme.space[2],
  marginBottom: ClinTheme.space[2]
})

export const Column = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: ClinTheme.space[3]
})

export const StyledStorage = styled.div({
  marginTop: ClinTheme.space[2]
})

export const StyledSuccessNotification = styled(ClinNotification)`
  position: relative;
  top: 20px;
  background-color: ${ClinTheme.colors.deepGreen};
  right: 0;
  > div {
    background-color: ${ClinTheme.colors.grey};
  }
  > button {
    background-color: inherit;
    color: ${ClinTheme.colors.white};
  }
`

export const StyledDocumentsAnnounceBar = styled(ClinAnnounceBar)`
  display: flex;
  margin: 0 0 24px 0;
  border: 0;
  border-radius: 5px;
  padding: 20px 24px;
  background-color: #fbf0e5;
  .clin-announce-bar-message {
    margin-left: 8px;
  }
  .clin-announce-bar-message-container {
    display: flex;
    align-items: center;
  }
  div.clin-announce-bar-text {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-between;
  }
`

export const StyledDocumentsAnnounceBarText = styled(ClinText)({
  marginLeft: ClinTheme.space[2]
})
